<script>
import ListForm from "../ListForm.vue";
import * as categoryService from "../../service/category.service";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
  },
  components: {
    ListForm,
  },
  data() {
    return {
      value: null,
      listData: [],
      selectedItem: {},
      prevSelectedItem: "", // Initialize as null or an equivalent valid state
      showListForm: false,
    };
  },
  computed: {
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.filter((x) => x.active).length;
    },
    filteredList() {
      return this.listData;
    },
  },
  watch: {
    topbarControls: {
      handler(val) {
        console.log("val", val);
        // Logging the current and new values for debugging purposes

        // Check if 'val' is not null or undefined, and has a property 'title' equal to "Options"
        if (val && (val.title === "Options" || val.title === "Tabs")) {
          // Additional check to ensure 'val.selectedItem' is not null, undefined, or empty
          if (val.selectedItem && Object.keys(val.selectedItem).length > 0) {
            // Now checking if 'selectedItem' is not undefined and both 'selectedItem' and 'val.selectedItem' are not equal
            if (
              this.selectedItem &&
              JSON.stringify(this.selectedItem) !==
                JSON.stringify(val.selectedItem)
            ) {
              this.selectedItem = val.selectedItem;
            }

            // Additional logic to handle list data updates
            if (!this.listData.some((x) => x.id === val.selectedItem.id)) {
              this.setSelectedItems(this.listData[0] || {});
            } else if (
              !val.listItems.some((x) => x.id === this.listData[0]?.id)
            ) {
              this.setTopbarControls(null, this.listData, null, null, null);
            }

            // Update 'listData' if it's different from 'val.listItems'
            if (
              JSON.stringify(this.listData) !== JSON.stringify(val.listItems)
            ) {
              this.listData = val.listItems;
            }
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    setSelectedItems(val) {
      console.log("setSelectedItems");
      this.selectedItem = val;
      this.prevSelectedItem = JSON.stringify(val || {}); // Ensure val is an object
      // Assuming `this.category` is defined elsewhere in your component
      this.setTopbarControls(
        null,
        this.listData,
        this.selectedItem,
        this.prevSelectedItem,
        this.category
      );
    },
    setListItems(val, sort) {
      this.listData = sort
        ? val.sort(
            (a, b) => a.additionalProp1.position - b.additionalProp1.position
          )
        : val;
      this.setSelectedItems(this.listData[0] || {});
    },
    updateValue(val) {
      this.value = val;
    },
    async getData() {
      const data = await categoryService.get(this.$route.params.categoryId);
      this.category = data;
      let options = data.additionalProp1.options;

      this.setListItems(options || [], false);
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>
<template>
  <ListForm
    :style="item.style"
    :class="`col-${item.size} ${item.class}`"
    :item="item"
    :items="item.children"
    :selectedItem="selectedItem"
    :listItems="listData"
    :prevSelectedItem="prevSelectedItem"
    :setSelectedItems="setSelectedItems"
    :topbarControls="topbarControls"
  />
</template>

<style scoped>
.simplebar-custom {
  max-height: calc(100vh - 300px);
  padding-right: 2em;
}
</style>
